import SearchInput, { SearchInputProps } from "./SearchInput";

const DebounceSearchInput = (props: SearchInputProps): JSX.Element => {
  const { debounce, ...rest } = props;
  return <SearchInput {...rest} debounce={debounce ?? 500} />;
};

export default DebounceSearchInput;
